import React from 'react';
import Energymanage from '../../Assets/elvotaimages/Energymanage.svg';
import Tower from '../../Assets/elvotaimages/Tower.svg';
import Evoltecard from '../../Assets/elvotaimages/Evoltecard.svg';
import Besscard from '../../Assets/elvotaimages/Besscard.svg';

export default function Energymangment() {
  return (
    <div className=" bg-black-light">
      <div className="  w-11/12 2xl:w-[1222px] mx-auto  pb-[74px] pt-6 ">
        <div className="grid grid-cols-12 gap-4 md:gap-0">
          <div className="col-span-12 lg:col-span-6">
            <h1 className="f-f-b-ex text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[44px] text-white pt-3 md:pt-5 lg:pt-10 xl:pt-[62px]  text-center lg:text-start">
              AI energy management optimization
            </h1>
          </div>
          <div className="col-span-12 lg:col-span-6">
            <img src={Energymanage} className="w-full xl:h-[409px]" alt="" />
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 sm:gap-[30px]">
          <div className="col-span-12 sm:col-span-6 lg:col-span-4 order-2 sm:order-none">
            <div className="relative bg-green-vdark rounded-xl mt-16 sm:mt-0 w-[96%] ">
              <div className="p-4 md:p-6 xl:p-0 xl:pl-[31px] xl:pr-[39px] xl:pb-[31px] xl:pt-[27px]">
                <h4 className="f-f-b-ex text-[22px] md:text-2xl text-white">
                  Electricity Grid
                </h4>
                <p className="f-f-m text-lg md:text-[18px] text-white mt-[10px]">
                  Intermittent renewable energies make the grid unstable and
                  drive electricity price volatility
                </p>
              </div>
              <div className="absolute top-[-85px] right-[18px] xl:right-[37px] z-10">
                <img
                  src={Tower}
                  className="w-[68px] h-[135px] md:h-[146px]"
                  alt=""
                />
              </div>
              <div className="absolute top-[23%] right-[-30px] w-0 h-0 border-t-[50px] border-t-transparent border-l-[39px] border-l-green-vdark border-b-[50px] border-b-transparent" />
            </div>
          </div>

          <div className="col-span-12 sm:col-span-6 lg:col-span-4 order-1 sm:order-none">
            <div className="relative bg-green-vdark rounded-xl mt-12 sm:mt-0 w-[96%] ">
              <div className="p-4 md:p-6 xl:p-0 xl:pl-[31px] xl:pr-[39px] xl:pb-[31px] xl:pt-[27px]">
                <h4 className="f-f-b-ex text-[22px] md:text-2xl text-white">
                  EVOLTA
                </h4>
                <p className="f-f-m text-lg md:text-[18px] text-white mt-[10px]">
                  Leverages <span className="text-green">AI</span> and
                  <span className="text-green"> Deep Learning </span> models to
                  decide when to charge/discharge the batteries.
                </p>
              </div>
              <div className="absolute top-[-52px] right-[18px] xl:right-[28px] z-10">
                <img
                  src={Evoltecard}
                  className="w-[110px] md:w-[135px] h-[89px] md:h-[95px]"
                  alt=""
                />
              </div>
              <div className="absolute top-[23%] right-[-30px] w-0 h-0 border-t-[50px] border-t-transparent border-l-[39px] border-l-green-vdark border-b-[50px] border-b-transparent" />
            </div>
          </div>

          <div className="col-span-12 sm:col-span-6 lg:col-span-4 h-full order-3 sm:order-none">
            <div className="relative bg-green-vdark rounded-xl mt-16 sm:mt-12 lg:mt-0 h-auto sm:h-full">
              <div className="p-4 md:p-6 xl:p-0 xl:pl-[31px] xl:pr-[39px] xl:pb-[31px] xl:pt-[27px]">
                <h4 className="f-f-b-ex text-[22px] md:text-2xl text-white">
                  BESS
                </h4>
                <p className="f-f-m text-lg md:text-[18px] text-white mt-[10px]">
                  The batteries are connected to the grid and stabilize the
                  whole system. <br />
                  <span>&nbsp;</span>
                </p>
              </div>
              <div className="absolute top-[-64px] right-[18px] xl:right-[18px] z-10">
                <img
                  src={Besscard}
                  className="w-[85px] md:w-[90px] h-[110px] md:h-[124px]"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
